import { useEffect, useState } from 'react';
import { getRequestForApi } from '../utility-files/api-util/CommonRequest';
import { callHttpRequest, methodType } from '../utility-files/api-util/HttpRequest';
import CustomLoader from '../custom-ui/CustomLoader';
import { useAlert } from "react-alert";
import { alertTypes } from '../utility-files/helper-function/HelperFunction';
import ThemeButton from '../qed-theme-module/ThemeButton';
import { SAVE_BULK_MESSAGE } from '../constants/global';
import TextEditor from '../qed-theme-module/TextEditor';
import { isStringValue } from '../utility-files/data-util/DataHandling';

function OwnerSendMessage({ onClose, data, selectedRows, isShowModel, onSuccess }) {
  const alert = useAlert();
  const [pending, setPending] = useState(false);
  const [sendMessage, setSendMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [formErrors, setFormErrors] = useState(null);


  // Prefill message when modal opens
  useEffect(() => {
    if (isShowModel && data?.message) {
      setSendMessage(data.message);
    } else {
      setSendMessage('');
    }
  }, [isShowModel, data]);


  // Detect real text (ignore <p><br></p> etc.)
const hasMeaningfulContent = (htmlString) => {
  if (!htmlString) return false;
  const text = String(htmlString)
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, "")
    .trim();
  return text.length > 0;
};


  const getbulkMessage = async () => {
    if (selectedRows.length === 0 || !hasMeaningfulContent(sendMessage)) return;

    setPending(true);
    setIsSaving(true);

    const recipientIds = selectedRows.map((item) => item.id);
    const variables = {
      recipientids: recipientIds,
      message: sendMessage
    };
    const request = getRequestForApi(SAVE_BULK_MESSAGE, variables, methodType.POST);

    try {
      const response = await callHttpRequest(request);
      if (response?.status === 201) {
        onSuccess();
        onClose();
        alert.show(response?.data?.message, { type: alertTypes.SUCCESS });
      }
    } catch (err) {
      alert.show(err?.response?.data?.message, { type: alertTypes.ERROR });
    } finally {
      setPending(false);
      setIsSaving(false);
    }
  };

  if (!isShowModel) return null;

  return (
    <>
      {pending && <CustomLoader />}
      <div
        className="modal fade show d-block bd-example-modal-sm page-over"
        tabIndex="0"
        aria-hidden="true"
        data-bs-keyboard="false"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg custom-modaladdlead">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-head d-flex gap-2">
                <i className="bi bi-chat-left-dots dots-custom" alt="icon" />
                <b>Send Message</b><span className="required">*</span>
              </div>
              <button
                type="button"
                className="small btn-close"
                aria-label="Close"
                onClick={() => onClose(false)}
              />
            </div>
            <div className="modal-body pt-0">
              <div className="modal-input-custom">
                <div className="form-outline">
                  <TextEditor
  value={sendMessage}
  onChange={setSendMessage}
/>

                </div>
              </div>
            </div>
            <div className="modal-footer d-flex px-4">
              <ThemeButton
                type="submit"
                className="btn btn-primary"
                onClick={getbulkMessage}
                disabled={!hasMeaningfulContent(sendMessage) || pending || isSaving}

              >
                Send
              </ThemeButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OwnerSendMessage;
